import { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import Navbar from '../sections/Navbar';
import Hero from '../sections/Hero';
import WebTypes from '../sections/WebTypes';
import Process from '../sections/Process';
import Pricing from '../sections/Pricing';
import Newsletter from '../sections/Newsletter';
import FAQ from '../sections/FAQ';
import CTA from '../sections/CTA';
import Footer from '../sections/Footer';
import ParticleBackground from '../components/ParticleBackground';

gsap.registerPlugin(ScrollTrigger);

const HomePage = () => {
  useEffect(() => {
    ScrollTrigger.refresh();
  }, []);

  return (
    <div className="relative min-h-screen overflow-x-hidden bg-gradient-to-b from-[#FAFBFC] to-[#F0F4F8]">
      {/* Particle Background */}
      <ParticleBackground />

      {/* Grid Pattern */}
      <div className="fixed inset-0 grid-pattern pointer-events-none z-[1]" />

      {/* Noise Texture Overlay */}
      <div className="fixed inset-0 pointer-events-none z-[2] opacity-[0.015]">
        <svg className="w-full h-full">
          <filter id="noise">
            <feTurbulence type="fractalNoise" baseFrequency="0.8" numOctaves="4" stitchTiles="stitch" />
          </filter>
          <rect width="100%" height="100%" filter="url(#noise)" />
        </svg>
      </div>

      {/* Content */}
      <div className="relative z-10">
        <Navbar />
        <main>
          <Hero />
          <WebTypes />
          <Process />
          <Pricing />
          <Newsletter />
          <FAQ />
          <CTA />
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default HomePage;
